/**
 * The one question a clinical window can be stuck on: which copy of a draft to
 * keep. useDraftManager publishes it here and DraftRecoveryPrompt, mounted once
 * at the app root, asks it, so every window that saves through the hook gets
 * the choice. Only two windows used to render it; the rest stopped autosaving
 * behind a generic "not saved" message (Sep 2026).
 *
 * A prompt: { kind: 'conflict' | 'existing', patientName, sessionDate,
 *             savedAt, details, actions } where actions is a ref whose
 *             .current holds the hook's latest keepLocalEdits,
 *             adoptServerDraft, openExistingDraft and dismissExistingDraft.
 */
const prompts = new Map();
const listeners = new Set();
let snapshot = null;

function emit() {
  snapshot = prompts.size ? [...prompts.entries()].map(([id, prompt]) => ({ id, ...prompt }))[0] : null;
  listeners.forEach((listener) => listener());
}

export function publishDraftRecovery(id, prompt) {
  prompts.set(id, prompt);
  emit();
}

export function clearDraftRecovery(id) {
  if (!prompts.delete(id)) return;
  emit();
}

export function subscribeDraftRecovery(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getDraftRecoverySnapshot() {
  return snapshot;
}
